export const withBase = (path: string) =>
  `${import.meta.env.BASE_URL}${path.replace(/^\//, "")}`;

export const LOGO_URL =
  "https://public.readdy.ai/ai/img_res/fa4434da-d3b5-4594-af2b-ec791147b5d3.png";

export const ORIGINAL_LOGO_URL =
  "https://storage.helloreaddy.io/project_files/d3c9533e-7034-4676-93c4-f4f1e85ba944/238ce4e1-9d19-419a-bde3-11574ce34f26_compressed_9A03EA44-62AC-483B-860A-F3398AA54688.webp";

export type NavChild = {
  label: string;
  en: string;
  path: string;
};

export type NavItem = {
  label: string;
  en: string;
  path: string;
  children?: NavChild[];
};

export const COMPANY_CHILDREN: NavChild[] = [
  { label: "代表挨拶", en: "Message", path: "/company/message" },
  { label: "役員紹介", en: "Officers", path: "/company/officers" },
  { label: "会社概要", en: "Overview", path: "/company/overview" },
  { label: "経営理念", en: "Philosophy", path: "/company/philosophy" },
  { label: "アクセス", en: "Access", path: "/company/access" },
];

export const NAV_ITEMS: NavItem[] = [
  { label: "TOP", en: "Top", path: "/" },
  {
    label: "企業情報",
    en: "Company",
    path: "/company",
    children: COMPANY_CHILDREN,
  },
  { label: "グループ企業", en: "Group", path: "/group" },
  { label: "採用情報", en: "Recruit", path: "/recruit" },
];

export type Business = {
  no: string;
  title: string;
  en: string;
  desc: string;
  value: string;
  points: string[];
};

export const BUSINESSES: Business[] = [
  {
    no: "01",
    title: "営業支援・人材育成事業",
    en: "Sales Enablement",
    desc: "営業戦略の設計から営業組織の立ち上げ、研修・マネジメントまでを一貫して支援します。",
    value: "「売れる仕組み」と「育つ組織」を同時につくり、成果が続く営業力を残します。",
    points: ["営業戦略設計", "営業組織構築", "研修・教育支援"],
  },
  {
    no: "02",
    title: "フィールドセールス事業",
    en: "Field Sales",
    desc: "住宅設備や通信サービスなどを、法人・個人のお客様へ対面で提案・販売します。",
    value: "お客様一人ひとりに向き合い、本当に必要な商品・サービスをお届けします。",
    points: ["法人・個人向け対面営業", "販売支援・営業代行", "商談設計"],
  },
  {
    no: "03",
    title: "イベントプロモーション事業",
    en: "Event Promotion",
    desc: "商業施設やイベント会場での催事企画・集客・実演販売を、企画から運営まで担います。",
    value: "人と商品が出会う「場」をつくり、売上とブランド認知の両方を伸ばします。",
    points: ["催事企画・運営", "集客プロモーション", "会場・実演販売支援"],
  },
  {
    no: "04",
    title: "マーケティング支援事業",
    en: "Marketing Support",
    desc: "SNS運用、Web集客、広告運用、販促企画、ブランディングをワンストップで支援します。",
    value: "オンラインとリアルの接点をつなぎ、選ばれ続けるブランドを育てます。",
    points: ["SNS・Web集客", "広告運用", "販促企画・ブランディング"],
  },
  {
    no: "05",
    title: "DX支援事業",
    en: "DX Consulting",
    desc: "AI・RPA・業務システムの選定から導入・定着までを伴走し、業務の効率化を進めます。",
    value: "ムダな作業を減らし、人が本来の価値を発揮できる時間を生み出します。",
    points: ["AI・RPA導入", "業務効率化", "システム選定支援"],
  },
  {
    no: "06",
    title: "飲食事業",
    en: "Food & Beverage",
    desc: "愛知県産のお茶や食材を活かした飲食ブランド「一誠茶園」を運営しています。",
    value: "地域の恵みの魅力を磨き上げ、国内外へ発信します。",
    points: ["日本茶ブランド運営", "愛知の食の発信", "国内外への展開"],
  },
];

export type Value = {
  no: string;
  ja: string;
  en: string;
  desc: string;
};

export const VALUES: Value[] = [
  { no: "01", ja: "挑戦", en: "Challenge", desc: "挑戦の先に、新しい価値を" },
  { no: "02", ja: "仲間", en: "Team", desc: "一人では見られない景色を、仲間と共に" },
  { no: "03", ja: "誠実", en: "Integrity", desc: "目先の利益より、長く続く信頼を" },
  { no: "04", ja: "感謝", en: "Gratitude", desc: "ご縁を大切に、感謝をカタチに" },
  { no: "05", ja: "熱量", en: "Passion", desc: "想いには、想いで応える" },
];

export type Officer = {
  role: string;
  roleEn: string;
  name: string;
  message: string;
};

export const OFFICERS: Officer[] = [
  {
    role: "Founder",
    roleEn: "Founder",
    name: "山田 海大",
    message:
      "変革の起点は、いつも人の想いにある。挑戦する人のそばで、その熱量を価値に変えていく。",
  },
  {
    role: "代表取締役",
    roleEn: "Representative Director",
    name: "河出 享一郎",
    message:
      "一人ひとりの可能性に投資することが、次の時代を創る最短の道。信頼を積み重ね、会社と仲間の成長を追求します。",
  },
];

export type GroupCompany = {
  name: string;
  en: string;
  /** 公式サイト未確定の場合は undefined（リンクを出さない） */
  url?: string;
  field: string;
  tagline?: string;
  desc: string;
  image: string;
};

export const GROUP_COMPANIES: GroupCompany[] = [
  {
    name: "中京建設",
    en: "Chukyo Kensetsu",
    url: "https://chukyokensetsu.jp",
    field: "住宅設備・リフォーム",
    desc: "住宅設備やリフォームの提案営業を通じて、お客様のニーズに寄り添い、快適な住環境づくりをサポートします。",
    image: withBase("/images/group/chukyo-kensetsu.png"),
  },
  {
    name: "ライオンイーグル",
    en: "Lion Eagle",
    url: "https://lioneagle.jp/",
    field: "通信サービス販売",
    desc: "商業施設などで通信サービスの販売を通じ、お客様一人ひとりに最適な通信環境を提案し、快適な暮らしを支えます。",
    image: withBase("/images/group/lion-eagle.png"),
  },
  {
    name: "一誠茶園",
    en: "Issei Chaen",
    url: "https://isseichaen.com/",
    field: "飲食・日本茶",
    tagline: "愛知の恵みを、世界へ。",
    desc: "愛知県の豊かな自然が育んだお茶や食の魅力を発信し、地域の価値を国内外へ届けます。",
    image: withBase("/images/group/issei-chaya.png"),
  },
];

export type RequirementRow = { label: string; value: string };

const BASE_REQUIREMENTS: RequirementRow[] = [
  { label: "雇用形態", value: "正社員（試用期間あり）" },
  { label: "勤務地", value: "未定（決定次第ご案内いたします）" },
  { label: "勤務時間", value: "応相談" },
  { label: "給与", value: "経験・能力を考慮のうえ決定" },
  { label: "休日休暇", value: "完全週休二日制（土日祝）、夏季・年末年始休暇" },
  { label: "応募方法", value: "お問い合わせフォームよりご応募ください" },
];

export type RecruitJob = {
  slug: string;
  title: string;
  en: string;
  summary: string;
  requirements: RequirementRow[];
};

export type RecruitCategory = {
  slug: string;
  title: string;
  en: string;
  desc: string;
  jobs: RecruitJob[];
};

export const RECRUIT_CATEGORIES: RecruitCategory[] = [
  {
    slug: "sales",
    title: "営業",
    en: "Sales",
    desc: "法人・個人のお客様と向き合い、対面営業や販売支援を通じて価値を届けます。",
    jobs: [
      {
        slug: "field-sales",
        title: "フィールドセールス",
        en: "Field Sales",
        summary: "イベント・催事の現場で、お客様への提案から成約までを担います。",
        requirements: [
          { label: "募集職種", value: "フィールドセールス" },
          { label: "業務内容", value: "イベント・催事での対面営業、提案、成約対応" },
          ...BASE_REQUIREMENTS,
        ],
      },
      {
        slug: "corporate-sales",
        title: "法人営業",
        en: "Corporate Sales",
        summary: "既存・新規のお客様に対し、課題解決型の提案営業を行います。",
        requirements: [
          { label: "募集職種", value: "法人営業" },
          { label: "業務内容", value: "法人顧客への提案営業、商談設計、既存顧客フォロー" },
          ...BASE_REQUIREMENTS,
        ],
      },
    ],
  },
  {
    slug: "marketing",
    title: "マーケティング",
    en: "Marketing",
    desc: "SNS・Web施策やブランディングを通じて、集客と認知拡大を支援します。",
    jobs: [
      {
        slug: "web-marketing",
        title: "Webマーケティング",
        en: "Web Marketing",
        summary: "Web広告運用やサイト改善を通じて、集客・成果向上を支援します。",
        requirements: [
          { label: "募集職種", value: "Webマーケティング" },
          { label: "業務内容", value: "Web広告運用、サイト分析・改善、集客施策の企画" },
          ...BASE_REQUIREMENTS,
        ],
      },
      {
        slug: "sns-marketing",
        title: "SNSマーケティング",
        en: "SNS Marketing",
        summary: "SNSアカウント運用を通じて、ブランドの認知拡大に取り組みます。",
        requirements: [
          { label: "募集職種", value: "SNSマーケティング" },
          { label: "業務内容", value: "SNSアカウント運用、コンテンツ企画・制作、効果測定" },
          ...BASE_REQUIREMENTS,
        ],
      },
    ],
  },
  {
    slug: "consulting",
    title: "コンサルティング",
    en: "Consulting",
    desc: "AI・RPA導入や業務改善など、企業のDX推進を支援します。",
    jobs: [
      {
        slug: "dx-consultant",
        title: "DXコンサルタント",
        en: "DX Consultant",
        summary: "AI・RPA・システム導入の提案から実行までを一貫して支援します。",
        requirements: [
          { label: "募集職種", value: "DXコンサルタント" },
          { label: "業務内容", value: "業務課題のヒアリング、システム選定支援、導入・定着支援" },
          ...BASE_REQUIREMENTS,
        ],
      },
    ],
  },
  {
    slug: "corporate",
    title: "コーポレート",
    en: "Corporate",
    desc: "人事・総務・経理など、事業と組織の成長を裏側から支えます。",
    jobs: [
      {
        slug: "hr",
        title: "人事・採用",
        en: "HR / Recruiting",
        summary: "採用計画の立案から入社後のフォローまで、人と組織づくりを担います。",
        requirements: [
          { label: "募集職種", value: "人事・採用" },
          { label: "業務内容", value: "採用計画立案、面接対応、入社後のオンボーディング支援" },
          ...BASE_REQUIREMENTS,
        ],
      },
      {
        slug: "admin",
        title: "経理・総務",
        en: "Accounting / Admin",
        summary: "経理業務や労務管理など、組織運営の土台を支えます。",
        requirements: [
          { label: "募集職種", value: "経理・総務" },
          { label: "業務内容", value: "経理業務、労務管理、社内制度の整備・運用" },
          ...BASE_REQUIREMENTS,
        ],
      },
    ],
  },
];

export type FaqItem = { q: string; a: string };

export const RECRUIT_FAQS: FaqItem[] = [
  {
    q: "未経験でも応募できますか？",
    a: "はい、経験の有無よりも意欲を重視しています。入社後の研修・OJTを通じてサポートいたします。",
  },
  {
    q: "選考の流れを教えてください。",
    a: "お問い合わせフォームからのご応募後、書類選考、面接（1〜2回）を経て内定となります。",
  },
  {
    q: "勤務地はどこになりますか？",
    a: "勤務地は決定次第、個別にご案内いたします。詳細は各募集職種のページをご確認ください。",
  },
  {
    q: "副業やリモートワークは可能ですか？",
    a: "職種や業務内容に応じてご相談を承っております。まずはお問い合わせください。",
  },
];